import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const TicketsQueueSelect = ({
	userQueues,
	selectedQueueIds = [],
	onChange,
}) => {
	const placeholder = i18n.t("ticketsQueueSelect.placeholder");

	const handleChange = e => {
		onChange(e.target.value);
	};

	return (
		<div style={{ width: 120, marginTop: -4 }}>
			<FormControl fullWidth margin="dense" size="small" variant="outlined">
				<InputLabel>{placeholder}</InputLabel>
				<Select
					multiple
					variant="outlined"
					value={selectedQueueIds}
					onChange={handleChange}
					label={placeholder}
					SelectDisplayProps={{
						style: {
							overflow: "hidden",
							whiteSpace: "nowrap",
						},
					}}
					renderValue={selected =>
						selected.length
							? userQueues
									.filter(queue => selected.includes(queue.id))
									.map(queue => queue.name)
									.join(", ")
							: ""
					}
				>
					{userQueues?.length > 0 &&
						userQueues.map(queue => (
							<MenuItem key={queue.id} value={queue.id}>
								<Checkbox
									style={{
										color: queue.color,
									}}
									color="primary"
									checked={selectedQueueIds.indexOf(queue.id) > -1}
								/>
								<ListItemText primary={queue.name} />
							</MenuItem>
						))}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsQueueSelect;

